import React, { useState, useEffect } from "react";
import { Alert, Box, Collapse } from "@mui/material";
import { WifiOff as OfflineIcon } from "@mui/icons-material";

function OfflineIndicator() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return (
    <Collapse in={!isOnline}>
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 9999,
        }}
      >
        <Alert
          severity="warning"
          icon={<OfflineIcon />}
          sx={{
            borderRadius: 0,
            fontWeight: "bold",
          }}
        >
          You are offline. Viewing cached data that may not be up to date.
        </Alert>
      </Box>
    </Collapse>
  );
}

export default OfflineIndicator;
